import { useMemo } from 'react';
import { LaboratoryResultMise } from '../../../graphql/graphql';
import useTranslation from '../../../Hooks/useTranslation';

export default function useLaboratoryResultMiseHelper(
	laboratoryResultMise: LaboratoryResultMise,
) {
	const { t } = useTranslation();

	const patient: string = useMemo(() => {
		return `${t('base.shared.patient')}, ${
			laboratoryResultMise.laboratoryResult?.user?.profile?.age
		} ${t('base.years.many')}, ${
			laboratoryResultMise.laboratoryResult?.user?.profile?.formattedGender
		}`;
	}, [laboratoryResultMise]);

	return { patient };
}
